<div class="file-picker-container">
  <div class="file-picker-container-button">
    <input #chooseFile id="chooseFile" type="file" multiple (change)="onFileChange($event)" />
    <a (click)="openFileDialog()">Izberi datoteko</a>
  </div>


  <div class="file-picker-selected-files">
    @if (files.length > 0) {
      <table class="files linked-files-comp">
        <tr>
          <th>{{translationsService.translations.File}}</th>
          <th>{{translationsService.translations.Type}}</th>
          <th>{{translationsService.translations.Size}}</th>
          <th></th>
        </tr>
        @for (file of files; track file) {
          <tr>
            <td>
              <div class="icon {{file.Extension.toLowerCase()}}">
                <div></div>
                <p>{{file.Name}}</p>
              </div>
            </td>
            <td>{{file.Extension}}</td>
            <td>{{file.Size}}</td>
            <td class="remove-file" (click)="removeFile(file)"><img src="../../../../../../Content/css/Images/icon-close.png" /></td>
          </tr>
        }
      </table>
    }
  </div>

</div>